module.exports = __webpack_public_path__ + "img/order_done.ef4184fb.png";